export default {
  appName: 'HAIDI',
  index: '/haiDashboard',
  loadingComponent: 'LoadingSpinnerPage',
  notFoundComponent: 'NotFoundComponentBox',
  staticGroups: [
    {
      id: 'general',
      label: 'navigation.section.general',
    },
    {
      id: 'hai',
      label: 'navigation.section.hai',
    },
    {
      id: 'haiReports',
      label: 'navigation.section.haiReports',
    },
    {
      id: 'atbReports',
      label: 'navigation.section.atbReports',
    },
    {
      id: 'rf',
      label: 'navigation.section.rf',
    },
    {
      id: 'admin',
      label: 'navigation.section.admin',
    },
  ],
  staticRoutes: [
    {
      path: '/haiDashboard',
      component: 'HaidiDashboardLayoutContainer',
      label: 'navigation.route.haiDashboard',
      iconName: 'haidiDashboardIcon',
      group: 'hai',
      roles: ['HAI_VIEW_ROLE'],
    },
    {
      path: '/patients',
      component: 'PatientListLayoutContainer',
      label: 'navigation.route.patients',
      iconName: 'haidiPatientListIcon',
      group: 'hai',
      roles: ['HAI_VIEW_ROLE'],
    },
    {
      path: '/hais',
      component: 'HaiListLayoutContainer',
      label: 'navigation.route.hais',
      iconName: 'haidiHaiListIcon',
      group: 'hai',
      roles: ['HAI_VIEW_ROLE'],
    },
    {
      path: '/haiByHospitals',
      component: 'HospitalNetworkReportLayoutContainer',
      label: 'navigation.route.haiByHospitals',
      iconName: 'haidiHospitalGroupReportIcon',
      group: 'haiReports',
      roles: ['HAI_REPORT_VIEW_ROLE & DEPARTMENT:MULTI_HOSPITAL'],
    },
    {
      path: '/haiByDepartments',
      component: 'HospitalReportLayoutContainer',
      label: 'navigation.route.haiByDepartments',
      iconName: 'haidiHospitalReportIcon',
      group: 'haiReports',
      roles: ['HAI_REPORT_VIEW_ROLE'],
    },
    {
      path: '/departmentReport',
      component: 'DepartmentReportLayoutContainer',
      label: 'navigation.route.departmentReport',
      iconName: 'haidiDepartmentReportIcon',
      group: 'haiReports',
      roles: ['HAI_REPORT_VIEW_ROLE'],
    },
    {
      path: '/haiYearlyOverviewReport',
      component: 'HaiYearlyOverviewReportLayoutContainer',
      label: 'navigation.route.haiYearlyOverview',
      iconName: 'analytics1',
      group: 'haiReports',
      roles: ['HAI_REPORT_VIEW_ROLE'],
    },
    {
      path: '/haiByPathogens',
      component: 'HaiByPathogensReportLayoutContainer',
      label: 'navigation.route.haiByPathogens',
      iconName: 'haisByPathogenIcon',
      iconViewbox: '0 0 11 16',
      group: 'haiReports',
      roles: ['HAI_REPORT_VIEW_ROLE'],
    },
    {
      path: '/labs',
      component: 'LabResultsListContainer',
      label: 'navigation.route.atbReports.labList',
      iconName: 'haidiLabListIcon',
      group: 'atbReports',
      roles: ['ATB_REPORT_VIEW_ROLE'],
    },
    {
      path: '/antibiogram',
      component: 'AntibiogramLayoutContainer',
      label: 'navigation.route.antibiogram',
      iconName: 'haidiMedicineIcon',
      group: 'atbReports',
      roles: ['ATB_REPORT_VIEW_ROLE'],
    },
    {
      path: '/pathogenDetail',
      component: 'PathogenDetailContainer',
      label: 'navigation.route.atbReports.pathogenDetail',
      iconName: 'haisByPathogenIcon',
      iconViewbox: '0 0 11 16',
      group: 'atbReports',
      roles: ['ATB_REPORT_VIEW_ROLE'],
    },
    {
      path: '/settings',
      component: 'SettingsLayoutContainer',
      label: 'navigation.routeGroup.userSettings',
      hidden: true,
    },
  ],
  dynamicRoutes: [
    {
      id: 'patient',
      path: '/patients',
      paramsString: '/:patientId',
      component: 'PatientLayout',
      label: 'navigation.routeGroup.openPatients',
      iconClass: 'far fa-folder-open',
      redirectOnCloseRoute: '/',
      roles: ['HAI_VIEW_ROLE'],
    },
    {
      id: 'encounter',
      path: '/encounter',
      paramsString: '/:encounterId/document?/:documentId?',
      component: 'EncounterSharedLayout',
      label: 'navigation.routeGroup.openedDocuments',
      iconClass: 'far fa-file-alt',
      redirectOnCloseRoute: '/',
      roles: ['HAI_VIEW_ROLE'],
    },
    {
      id: 'document',
      path: '/document',
      paramsString: '/:documentId',
      component: 'EncounterSharedLayout',
      label: 'navigation.routeGroup.openedDocuments',
      iconClass: 'far fa-file-alt',
      redirectOnCloseRoute: '/',
      roles: ['HAI_VIEW_ROLE'],
    },
  ],
  dynamicGroups: [
    {
      ids: ['patient', 'encounter', 'document'],
      label: 'navigation.routeGroup.openedCases',
    },
  ],
};
